// extracted by mini-css-extract-plugin
module.exports = {"power-backup-K":"K_power-backup-K__nEaXa"};